/**
 * @generated SignedSource<<e0e1e6d15438d8b3dce33a4a2e342dd7>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateEventPayload",
            "kind": "LinkedField",
            "name": "updateEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfEvent",
                    "kind": "LinkedField",
                    "name": "eventEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCompensatoryTime",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditEventIsCompensatoryTimeMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditEventIsCompensatoryTimeMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "9e1c52429a0a536b8633616e19a16267",
            "id": null,
            "metadata": {},
            "name": "EditEventIsCompensatoryTimeMutation",
            "operationKind": "mutation",
            "text": "mutation EditEventIsCompensatoryTimeMutation(\n  $model: UpdateEventRequestInput!\n) {\n  updateEvent(model: $model) {\n    eventEdge {\n      node {\n        id\n        isCompensatoryTime\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "9ab634eec6f940d46e1c867b28d2dc5c";
export default node;
